export const DEPENDENT_CODE_LIST = [
  'TOPUP_COMMON',
];
